import React from "react";
import { Outlet } from "react-router";
import HIDHeader from "../../common/components/HIDHeader/HIDHeader";
import HIDFooter from "../../common/components/HIDFooter/HIDFooter";
import "../../common/styles/portalShell.scss";

const ResourcesLandingPage = () => {
  return (
    <div className="hid-portal-shell">
      <HIDHeader />
      <div style={{ minHeight: "calc(100vh - 156px)" }}>
        <Outlet />
      </div>
      <HIDFooter />
    </div>
  );
};

export default ResourcesLandingPage;
